export const ITEM = {
    VALID: "valid",
    INVALID: "invalid",
};

export const PRODUCTS = {
    SALAD: "SALAD",
    BOWLS: "BOWL",
    SOUP: "SOUP",
};

export const isMainDish = (item) => {
    return (
        item.category === PRODUCTS.SALAD ||
        item.category === PRODUCTS.BOWLS ||
        item.category === PRODUCTS.SOUP
    );
};